import Icon from '../../components/Icon.vue'

Icon.register({"regular/folder":{"width":512,"height":512,"paths":[{"d":"M464 128H272L208 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V176C512 149.5 490.5 128 464 128zM458 400H54C50.7 400 48 397.3 48 394V118A6-6 0 0 0 54 112H188.1L252.1 176H458A6-6 0 0 0 464 182V394A6-6 0 0 0 458 400z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/folder.js
// module id = 8LKq
// module chunks = 0